module.exports = __webpack_public_path__ + "img/ee0f62d13883a746e75b728d0f262f05.svg";